import { assets } from '@trashlab/api/src/domains/asset/schemas/assets';
import { location } from '@trashlab/api/src/domains/asset/schemas/location';
import { orders } from '@trashlab/api/src/domains/orders/schemas/orders';
import { product } from '@trashlab/api/src/domains/pricing/schemas/product';
import { sql } from 'drizzle-orm';
import {
  foreignKey,
  index,
  integer,
  pgEnum,
  pgTable,
  text,
  timestamp,
  uuid,
  varchar,
} from 'drizzle-orm/pg-core';
import {
  defaultFields,
  defaultHistoryFields,
} from '@trashlab/api/drizzle/default';
import { geolocation2 } from '@trashlab/api/src/domains/geo/schemas/geolocation';
import { identity_user } from '@trashlab/api/src/domains/identity/schemas/identity-user';
export const commitStatus = pgEnum('commitStatus', ['PENDING', 'COMMITTED']);

export const asset_movement = pgTable(
  'asset_movement',
  {
    ...defaultFields.fieldsWithTenantId(),
    lastModifiedBy: uuid('lastModifiedBy').references(() => identity_user.id),
    createdBy: uuid('createdBy').references(() => identity_user.id),
    legacySystemId: varchar('legacySystemId', { length: 255 }),
    assetId: uuid('assetId').references(() => assets.id),
    fromLocationId: uuid('fromLocationId').references(() => location.id),
    toLocationId: uuid('toLocationId').references(() => location.id),
    productId: uuid('productId').references(() => product.id),
    quantity: integer('quantity').default(0).notNull(),
    orderId: uuid('orderId').references(() => orders.id),
    movedAtTs: timestamp('movedAtTs', { withTimezone: true, mode: 'string' }),
    notes: text('notes').default('').notNull(),
    uniqueKey: text('uniqueKey'),
    commitStatus: commitStatus('commitStatus').default('PENDING').notNull(),
    geolocationId: uuid('geolocationId').references(() => geolocation2.id),
  },
  (table) => {
    return {
      from_location_merge_page_idx: index(
        'asset_movement_from_location_merge_page_idx',
      ).on(table.tenantId, table.fromLocationId, table.id),
      to_location_merge_page_idx: index(
        'asset_movement_to_location_merge_page_idx',
      ).on(table.tenantId, table.toLocationId, table.id),
      createdAtTs_idx: index('asset_movement_createdAtTs_idx').on(
        table.createdAtTs,
      ),
      latest: index('asset_movement_latest').on(
        table.tenantId,
        table.assetId,
        table.movedAtTs,
      ),
      tenant_asset_latest_active_idx: index(
        'asset_movement_tenant_asset_latest_active_idx',
      )
        .on(
          table.tenantId,
          table.assetId,
          table.movedAtTs.desc(),
          table.id.desc(),
        )
        .where(sql`${table.archivedAtTs} IS NULL`),
      tenantId_idx: index('asset_movement_tenantId_idx').on(table.tenantId),
      updatedAtTs_idx: index('asset_movement_updatedAtTs_idx').on(
        table.updatedAtTs,
      ),
      updatedAtTs_idx1: index('asset_movement_updatedAtTs_idx1').on(
        table.updatedAtTs.desc(),
      ),
      versionNumber_idx: index('asset_movement_versionNumber_idx').on(
        table.versionNumber,
      ),

      // New indexes for foreign keys
      assetId_idx: index('asset_movement_assetId_idx').on(table.assetId),
      fromLocationId_idx: index('asset_movement_fromLocationId_idx').on(
        table.fromLocationId,
      ),
      toLocationId_idx: index('asset_movement_toLocationId_idx').on(
        table.toLocationId,
      ),
      productId_idx: index('asset_movement_productId_idx').on(table.productId),
      orderId_idx: index('asset_movement_orderId_idx').on(table.orderId),
      geolocationId_idx: index('asset_movement_geolocationId_idx').on(
        table.geolocationId,
      ),

      //foreign keys
      asset_movement_assetId_fkey: foreignKey({
        columns: [table.assetId],
        foreignColumns: [assets.id],
        name: 'asset_movement_assetId_fkey',
      }),
      asset_movement_fromLocationId_fkey: foreignKey({
        columns: [table.fromLocationId],
        foreignColumns: [location.id],
        name: 'asset_movement_fromLocationId_fkey',
      }),
      asset_movement_orderId_fkey: foreignKey({
        columns: [table.orderId],
        foreignColumns: [orders.id],
        name: 'asset_movement_orderId_fkey',
      }),
      asset_movement_productId_fkey: foreignKey({
        columns: [table.productId],
        foreignColumns: [product.id],
        name: 'asset_movement_productId_fkey',
      }),
      asset_movement_toLocationId_fkey: foreignKey({
        columns: [table.toLocationId],
        foreignColumns: [location.id],
        name: 'asset_movement_toLocationId_fkey',
      }),
      asset_movement_geolocation2Id_fkey: foreignKey({
        columns: [table.geolocationId],
        foreignColumns: [geolocation2.id],
        name: 'asset_movement_geolocation2Id_fkey',
      }),
    };
  },
);

export const asset_movement_history = pgTable('asset_movement_history', {
  ...defaultHistoryFields.historyFieldsWithTenantId(),
  commitStatus: commitStatus('commitStatus').default('PENDING'),
  lastModifiedBy: uuid('lastModifiedBy'),
  createdBy: uuid('createdBy'),
  legacySystemId: varchar('legacySystemId', { length: 255 }),
  assetId: uuid('assetId'),
  fromLocationId: uuid('fromLocationId'),
  toLocationId: uuid('toLocationId'),
  productId: uuid('productId'),
  quantity: integer('quantity'),
  orderId: uuid('orderId'),
  movedAtTs: timestamp('movedAtTs', { withTimezone: true, mode: 'string' }),
  notes: text('notes'),
  uniqueKey: text('uniqueKey'),
  geolocationId: uuid('geolocationId'),
});
